/*
 * $Id:: index.js 2020/11/12 10:02 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';
import { t } from '../../providers';

import Button from '@material-ui/core/Button';

const ExternalLinks = ({ links, className = '', icon }) => (
    <React.Fragment>
        {links &&
            links.length > 0 &&
            links.map((linkItem, index) =>
                icon ? (
                    <Button key={index} className={className} startIcon={icon} onClick={() => window.open(`${linkItem['link']}`)}>
                        {t(linkItem['textKey'])}
                    </Button>
                ) : (
                    <a key={index} href={`${linkItem['link']}`} target={'_blank'} className={className}>
                        {t(linkItem['textKey'])}
                    </a>
                )
            )}
    </React.Fragment>
);

export default ExternalLinks;
